import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const cardTypeService = {
  getAllCardTypes,
  addCardType,
  getCardType
};

function getAllCardTypes() {
  return apiCall("GET", apiUrls.cardtypes.base);
}

function addCardType(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.cardtypes.base, request);
}

function getCardType(id) {
  return apiCall("GET", `${apiUrls.cardtypes.base}/${id}`);
}
